(() => {
  // Shared cycle origin; set to the publication time when this file is deployed.
  const origin = Date.parse('2026-11-03T08:38:59Z');
  const cycle = 17 * 60 * 60 * 1000;
  function update() {
    const elapsed = Math.max(0, Date.now() - origin);
    const seconds = Math.ceil((cycle - (elapsed % cycle)) / 1000);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const text = `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds % 60).padStart(2, '0')}s`;
    document.querySelectorAll('[data-bf-cycle]').forEach(element => {
      const clock = element.querySelector('[data-bf-clock]');
      if (clock) clock.textContent = text;
      element.hidden = false;
    });
  }
  update();
  setInterval(update, 1000);
  document.addEventListener('visibilitychange', update);
  document.addEventListener('shopify:section:load', update);
})();
